module.exports = __webpack_public_path__ + "static/media/dashboard.7a0f9ea8.svg";